import {Component, Inject, Input, OnInit, ViewChild, ElementRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {environment} from '../../../environments/environment';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import { FormControl } from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {AddNewConnectionComponent} from '../../data-catalogue-parent/data-catalogue-parent.component';

@Component({
  selector: 'app-create-alert',
  templateUrl: './create-alert.component.html',
  styleUrls: ['./create-alert.component.scss']
})
export class CreateAlertComponent implements OnInit {

  topicName: any;
  description: any;

  users: any;
  userGroups: any;

  progressLoading = false;

  dataLoading = true;

  @Input() partner: any;
  @Input() account: any;

  isEdit = false;


  @ViewChild('search') searchTextBox: ElementRef;
  selectFormControl = new FormControl();
  searchTextboxControl = new FormControl();
  selectedValues = [];
  filteredOptions: Observable<any[]>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<CreateAlertComponent>,
              private cfgSrv: ConfService,
              private platform: LeftpanelComponent) {
    if (data && data['partner']) {
      this.partner = data['partner'];
    }
    if (data && data['account']) {
      this.account = data['account'];
    }
    if (data && data['isEdit']) {
      this.isEdit = data['isEdit'];
    }
    if (data && data['topicName']) {
      this.topicName = data['topicName'];
    }
  }

  ngOnInit() {
    this.initializeData();
  }


  initializeData() {
    const payload = {
      partner: this.partner,
      account: this.account,
      significance: 'compose',
      intent: this.isEdit ? 'edit-alert' : 'create-alert'
    };
    if (this.isEdit) {
      payload['data'] = {topic: this.topicName};
    }
    this.cfgSrv.postCoreApi(environment.coreAPI.alertConfig.name, environment.coreAPI.alertConfig.version, payload).subscribe(data => {
      let res: any;
      res = data;
      if (this.isEdit) {
        res = res['items'];
      }
      this.users = res['users'];
      this.dataLoading = false;


      this.setupForm();
      if (this.isEdit) {
        this.description = res['alert']['description'];
        const uids = res['alert']['users'].map(function (item) {
          return item['id'];
        });
        this.setFormValues(uids);
      }

    }, error => {
      this.platform.handleErrorGracefully(error, 'Error while fetching users and user groups.');
      this.dialogRef.close();
    });
  }


  createAlert() {
    let uids = [];
    if (this.selectFormControl.value) {
      uids = this.selectFormControl.value.map(function (item) {
        return item['uid'];
      });
    }

    const payload = {
      partner: this.partner,
      account: this.account,
      significance: this.isEdit ? 'refurbish' : 'generate',
      intent: 'create-alert',
      data: {topic: this.topicName,
        description: this.description,
        uids: uids}
    };
    this.progressLoading = true;
    this.cfgSrv.postCoreApi(environment.coreAPI.alertConfig.name, environment.coreAPI.alertConfig.version, payload).subscribe(data => {
      let res: any;
      res = data;
      this.users = res['users'];
      this.progressLoading = false;
      this.platform.openSnackBar('Alert ' + (this.isEdit ? 'updated' : 'created') + ' successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.dialogRef.close(true);

    }, error => {
      this.platform.handleErrorGracefully(error, 'Error while ' + (this.isEdit ? 'updating' : 'creating') + ' alert.');
    });

  }

  private _filter(name: string): String[] {
    const filterValue = name.toLowerCase();
    this.setSelectedValues();
    this.selectFormControl.patchValue(this.selectedValues);
    const filteredList = this.users.filter(option => option.user.toLowerCase().indexOf(filterValue) === 0 || option.email.toLowerCase().indexOf(filterValue) === 0);
    return filteredList;
  }

  setupForm() {
    this.filteredOptions = this.searchTextboxControl.valueChanges
        .pipe(
            startWith<string>(''),
            map(name => this._filter(name))
        );

  }

  /**
   * Remove from selected values based on uncheck
   */
  selectionChange(event) {
    if (event.isUserInput && event.source.selected === false) {
      const index = this.selectedValues.indexOf(event.source.value);
      this.selectedValues.splice(index, 1);
    }
  }

  openedChange(e) {
    this.searchTextboxControl.patchValue('');
    // Focus to search textbox while clicking on selectbox
    if (e === true) {
      this.searchTextBox.nativeElement.focus();
    }
  }

  /**
   * Clearing search textbox value
   */
  clearSearch(event) {
    event.stopPropagation();
    this.searchTextboxControl.patchValue('');
  }

  /**
   * Set selected values to retain the state
   */
  setSelectedValues() {
    if (this.selectFormControl.value && this.selectFormControl.value.length > 0) {
      this.selectFormControl.value.forEach((e) => {
        if (this.selectedValues.indexOf(e) === -1) {
          this.selectedValues.push(e);
        }
      });
    }
  }

  setFormValues(selectedValues) {
    if (selectedValues && selectedValues.length > 0) {
      const sss = [];
      selectedValues.forEach((e) => {
        const index = this.users.findIndex(value => value['uid'] === e);
        if (index !== -1) {
          sss.push(this.users[index]);
        }
      });
      this.selectFormControl.setValue(sss);
    }
  }

}


@Component({
  selector: 'app-alert-database-input',
  templateUrl: './alert-database-input.component.html',
  styleUrls: ['./create-alert.component.scss']
})
export class AlertDatabaseInputComponent implements OnInit {


  dataLoading = true;
  databases: any;

  mongoDatabases = [];
  selectDatabase: any;

  @Input() partner: any;
  @Input() account: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<CreateAlertComponent>,
              private cfgSrv: ConfService,
              public platform: LeftpanelComponent,
              public dialog: MatDialog) {
    if (data && data['partner']) {
      this.partner = data['partner'];
    }
  }

  ngOnInit() {
    Promise.resolve(this.setupDatabases()).then(response => {
      this.setupMongoDatabases();
      this.dataLoading = false;
    }, error => {
      this.dialogRef.close(false);
    });
  }

  addDatabase() {
    const dialogRef = this.dialog.open(AddNewConnectionComponent, {
      height: '85vh',
      width: '60vw',
      panelClass: 'dialog-color',
      data: {fromDataCatalog: true}
    });

    this.dataLoading = true;

    dialogRef.afterClosed().subscribe(result => {
      Promise.resolve(this.setupDatabases(true)).then(response => {
        this.setupMongoDatabases();
        this.dataLoading = false;
      }, error => {
        this.dialogRef.close(false);
      });
    });

  }

  setupMongoDatabases() {
    this.mongoDatabases = [];
    for (const databaseRecord of this.databases) {
      if (databaseRecord.database_type === 'mongodb') {
        this.mongoDatabases.push(databaseRecord);
      }
    }
  }


  setupDatabases(force = false) {
    return new Promise(async (resolve, reject) => {
      if (this.platform.databases !== null && this.platform.databases !== undefined && !force) {
        await this.platform.updateIsNoSQLForMongo(this.platform.databases);
        this.databases = this.platform.databases;
        resolve('success');
      } else {
        // this.platform.getDatabasesForPartnerAccount();
        await this.cfgSrv.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
              await this.platform.updateIsNoSQLForMongo(databases);
              this.databases = this.platform.databases;
              resolve('success');
        },
        error => {
          this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
          reject();
        });
      }
    });
  }

  createAlertManager() {
    if (this.selectDatabase && this.selectDatabase !== '') {
      this.dialogRef.close({database: this.selectDatabase});
    } else {
      this.platform.openSnackBar('Please select a valid database to continue', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }
}
